import React from 'react';
import clsx from 'clsx';

const FilterBarWrapper = props => {
  const { isSticky, withHeader } = props;

  return (
    <div
      className={clsx(
        'card',
        isSticky && ['fixed', 'top-0', 'shadow lg:shadow-none'],
        withHeader ? 'translate-y-[50px]' : 'translate-y-0',
      )}
    >
      {props.children}
    </div>
  );
};

export default FilterBarWrapper;
